<template>
  <div class="confirmation-wrapper">
    <div class="confirmation-box">
      <h1>{{ translations.order.title }}</h1>
      <p>{{ translations.order.success }}</p>

      <p v-if="orderNumber" class="order-number">
        {{ translations.order.number }} <strong>{{ orderNumber }}</strong>
      </p>

      <p v-else class="order-number error">
        {{ translations.order.error }}<br />
        {{ translations.order.contact }}:
        <a href="mailto:biuro@birdstool.pl">biuro@birdstool.pl</a> {{ translations.order.or }}
        <a href="tel:+48720992745">+48 720 992 745</a>
      </p>

      <router-link to="/" class="btn-return">
        ← {{ translations.order.back_home }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { translations } from '@/locales/lang'
import eventBus from "@/eventBus"
import { track } from '@/tracking/events'

export default {
  name: 'AppOrderConfirmation',
  computed: {
    translations() {
      return translations.value
    },
    orderNumber() {
      return this.$route?.query?.order || null
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    eventBus.emit("cartUpdated")

    // ✅ Wysyłka eventu "purchase" tylko jeśli mamy numer zamówienia i jeszcze nie wysłano
    if (this.orderNumber && !sessionStorage.getItem(`purchase_sent_${this.orderNumber}`)) {
      try {
        const cartData = JSON.parse(localStorage.getItem('cart_backup') || '[]')

        if (Array.isArray(cartData) && cartData.length > 0) {
          const currency = localStorage.getItem('currency_code') || 'PLN'
          const shipping = Number(localStorage.getItem('shipping_price') || 0)
          const tax = 0

          track.purchase({
            transaction_id: this.orderNumber,
            items: cartData.map(item => ({
              id: item.id,
              product_id: item.id,
              product_name: item.name,
              variant: item.variant,
              sku: item.variant?.sku,
              price: item.price,
              quantity: item.quantity
            })),
            currency,
            shipping,
            tax
          })
        }
      } catch (e) {
        console.error('Błąd przy trackowaniu purchase:', e)
      }

      // 🔒 zabezpieczenie: żeby event nie wysłał się 2x po refreshu
      sessionStorage.setItem(`purchase_sent_${this.orderNumber}`, '1')
    }

    // Czyścimy koszyk po wysyłce
    localStorage.removeItem("cart")
    localStorage.removeItem("cart_backup")
  }
}
</script>


<style scoped>
.confirmation-wrapper {
  background: #f2f4f7;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  overflow: hidden; /* ✅ zapobiega przesuwaniu */
  position: relative;
}

.confirmation-box {
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.confirmation-box h1 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.confirmation-box p {
  font-size: 1.1rem;
  margin: 10px 0;
}

.order-number {
  font-size: 1.2rem;
  font-weight: 600;
  color: #111;
  margin-top: 20px;
}

.success {
  color: green;
  font-weight: bold;
  font-size: 20px;
}

.failed {
  color: red;
  font-weight: bold;
  font-size: 20px;
}

.pending {
  color: orange;
  font-weight: bold;
  font-size: 18px;
}

.btn-return {
  display: inline-block;
  margin-top: 32px;
  padding: 14px 28px;
  background: #111;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.2s ease;
}

.btn-return:hover {
  background: #000;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}
</style>
